import { render, staticRenderFns } from "./ReviewAndPay.vue?vue&type=template&id=1202050e&scoped=true&"
import script from "./ReviewAndPay.vue?vue&type=script&lang=js&"
export * from "./ReviewAndPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202050e",
  null
  
)

export default component.exports